import { render, staticRenderFns } from "./material-currency-info.vue?vue&type=template&id=29e74006&scoped=true&"
import script from "./material-currency-info.vue?vue&type=script&lang=js&"
export * from "./material-currency-info.vue?vue&type=script&lang=js&"
import style0 from "./material-currency-info.vue?vue&type=style&index=0&id=29e74006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e74006",
  null
  
)

export default component.exports